module.exports = __webpack_public_path__ + "img/gaelicfootball.7e5a4835.svg";